import { z } from 'zod';
const LABEL = /^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;
const TLD = /^[a-z]{2,63}$/;
/**
 * Un nombre de host de dominio propio (`suite.ansv.gov.co`): minúsculas, al menos dos etiquetas, la última de letras;
 * nada de esquema, puerto, ruta, comodines ni direcciones IP. Lo que el cliente pone en su DNS.
 */
export function isHost(value) {
    if (!value || value.length > 253 || value.endsWith('.'))
        return false;
    const labels = value.split('.');
    return labels.length >= 2 && labels.every((l) => LABEL.test(l)) && TLD.test(labels[labels.length - 1]);
}
export const HOST_HINT = 'Escribe solo el nombre del dominio, sin https:// ni rutas: suite.entidad.gov.co';
/** Normaliza (minúsculas, sin espacios) y valida un host. */
export const hostSchema = z.string().trim().toLowerCase().max(253, 'El dominio es demasiado largo').refine(isHost, HOST_HINT);
export const entityDomainInputSchema = z.object({ host: hostSchema });
/** Estado de un dominio propio según `verified_at` y `tls_asked_at`. */
export const DomainStatus = { UNVERIFIED: 'UNVERIFIED', VERIFIED: 'VERIFIED', CERTIFIED: 'CERTIFIED' };
export const DOMAIN_STATUS_LABEL = { UNVERIFIED: 'Sin apuntar', VERIFIED: 'Apuntado', CERTIFIED: 'Con certificado' };
export function domainStatus(d) {
    if (!d.verifiedAt)
        return 'UNVERIFIED';
    return d.tlsAskedAt ? 'CERTIFIED' : 'VERIFIED';
}
/** Salto de la sesión del portal al host canónico (`POST /v1/auth/handoff`): a qué ruta del portal volver. */
export const HANDOFF_TTL_SECONDS = 60;
export const handoffRequestSchema = z.object({
    returnTo: z.string().max(2000).refine((v) => v.startsWith('/') && !v.startsWith('//') && !v.startsWith('/\\'), 'Debe ser una ruta del portal').default('/'),
});
//# sourceMappingURL=domains.js.map